var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99964 0C5.35858 0 2.07549 2.19384 0.684528 5.55363C-0.706438 8.91854 0.0606387 12.7897 2.63802 15.362C5.21539 17.9342 9.08146 18.7064 12.4464 17.3155C15.8062 15.9245 18 12.6414 18 9.00036C17.9949 4.02971 13.9703 0.00511384 8.99964 0ZM8.99964 16.3643C6.02338 16.3643 3.3335 14.5693 2.19823 11.8181C1.05784 9.06684 1.68684 5.90137 3.79374 3.79447C5.90065 1.68757 9.06612 1.05857 11.8174 2.19895C14.5686 3.33934 16.3636 6.02411 16.3636 9.00036C16.3585 13.0659 13.0651 16.3592 8.99964 16.3643Z",
    fill: "url(#paint0_linear_1_8695)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81612 8.6627V4.09092C9.81612 3.6409 9.44792 3.27271 8.9979 3.27271C8.54788 3.27271 8.17969 3.6409 8.17969 4.09092V9.00021C8.17969 9.21499 8.26662 9.42466 8.42004 9.57807L10.8747 12.0327C11.1969 12.3447 11.7082 12.3395 12.0202 12.0225C12.3372 11.7054 12.3424 11.194 12.0304 10.877L9.81612 8.6627Z",
    fill: "url(#paint1_linear_1_8695)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8695",
    x1: 0.000771539,
    y1: 7.8746,
    x2: 18.0006,
    y2: 7.8746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_8695",
    x1: 8.17986,
    y1: 7.20623,
    x2: 12.2614,
    y2: 7.20623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon-15.c9b725bef8e6e2e381b31c1bbe278f29.svg";
export { ForwardRef as ReactComponent };